import { useState } from 'react';
import { Button, useDataProvider, useNotify, useRefresh } from 'react-admin';
import { Alert, Box, Button as MuiButton, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { fetchAllMeInvoices, mapMeInvoiceRow } from '../services/meInvoiceClient';
import { syncInvoicesFromMeInvoice } from '../services/meInvoiceSync';
import { formatVnd } from '../utils/format';
import { dataTableScrollSx } from '../ui';

export function MeInvoiceImportButton() {
  const dp = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [rows, setRows] = useState<ReturnType<typeof mapMeInvoiceRow>[]>([]);
  const [total, setTotal] = useState(0);

  const preview = async () => {
    setOpen(true); setLoading(true); setError(''); setRows([]);
    try {
      const page = await fetchAllMeInvoices({ pageSize: 100 });
      setRows(page.rows.map(mapMeInvoiceRow)); setTotal(page.total);
    } catch (reason: any) { setError(String(reason?.message || 'Không thể tải dữ liệu từ meInvoice.')); }
    finally { setLoading(false); }
  };
  const importRows = async () => {
    setLoading(true);
    try {
      const result = await syncInvoicesFromMeInvoice(dp);
      notify(`meInvoice: ${result.created} thêm, ${result.updated} cập nhật, ${result.skipped} bỏ qua, ${result.invalid} không hợp lệ.`, { type: result.invalid ? 'warning' : 'success' });
      setOpen(false); refresh();
    } catch (reason: any) { setError(String(reason?.message || 'Không thể đồng bộ meInvoice.')); }
    finally { setLoading(false); }
  };
  return <>
    <Button label="Lấy HĐ từ meInvoice" onClick={preview} startIcon={<CloudDownloadIcon />} />
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
      <DialogTitle>Lấy hóa đơn đầu vào từ MISA meInvoice</DialogTitle>
      <DialogContent>
        {loading ? <Box sx={{ display: 'flex', gap: 2, py: 2 }}><CircularProgress size={20} /> Đang kết nối meInvoice…</Box>
          : error ? <Alert severity="error">{error}</Alert>
          : <><Alert severity={rows.length ? 'success' : 'info'} sx={{ mb: 2 }}>Đọc được {rows.length} dòng (tổng {total}) từ meInvoice.</Alert>
            <TableContainer component={Box} tabIndex={0} role="region" aria-label="Bảng xem trước hóa đơn meInvoice" sx={dataTableScrollSx}><Table size="small" sx={{ minWidth: 640 }}>
              <TableHead><TableRow><TableCell>Số HĐ</TableCell><TableCell>Nhà cung cấp</TableCell><TableCell>MST</TableCell><TableCell>Ngày</TableCell><TableCell align="right">Số tiền</TableCell></TableRow></TableHead>
              <TableBody>{rows.slice(0, 20).map((row, index) => <TableRow key={index}><TableCell>{row.invoiceNumber}</TableCell><TableCell>{row.supplierName}</TableCell><TableCell>{row.taxCode}</TableCell><TableCell>{row.invoiceDate}</TableCell><TableCell align="right">{formatVnd(row.amount)}</TableCell></TableRow>)}</TableBody>
            </Table></TableContainer></>}
      </DialogContent>
      <DialogActions><MuiButton onClick={() => setOpen(false)}>Đóng</MuiButton><MuiButton variant="contained" disabled={!rows.length || loading} onClick={importRows}>Nhập {rows.length} HĐ</MuiButton></DialogActions>
    </Dialog>
  </>;
}
